// // uat and prod
import React, { useEffect, useState, useRef } from "react";
import "./ResultPage.css"; // Your existing CSS
import Layout from "./Layout";
import downloadIcon from "../assets/download_icon.png";
// import shareIcon from "../assets/share_icon.png";
import html2canvas from 'html2canvas';
import { useLocation } from "react-router-dom"; // <-- IMPORT useLocation
import { useNavigate } from "react-router-dom"; // <-- IMPORT useNavigate
import { useBackground } from '../context/BackgroundContext'; 
// import resultBgDesktop from '../assets/login_page_4k.jpg';
// import resultBgMobile from '../assets/login_phone.jpg';
import resultBgDesktop from '../assets/login_page_4k_latest.jpg';
import resultBgMobile from '../assets/login_phone_long.jpg';

// uat
import { encryptAES, decryptAES } from "../utils/cryptoUtils";
import { useAuth } from '../context/AuthContext';
import { createApiClient } from '../utils/api';
import { useSessionKey } from '../context/SessionKeyContext';

const ResultPage = () => {
  const [imageURL, setImageURL] = useState("");
  const [childName, setChildName] = useState("");
  const [childDream, setChildDream] = useState("");
  const [childDOB, setChildDOB] = useState("");
  const [canProcess, setCanProcess] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // Combined loading state

  const frameContainerRef = useRef(null);
  const navigate = useNavigate(); // <-- INITIALIZE useNavigate
  const location = useLocation(); // <-- INITIALIZE useLocation
  const { changeBackground } = useBackground();

  // uat
  const { sessionKey } = useSessionKey();
  const { apiJwt } = useAuth();
  const apiClient = createApiClient(apiJwt);

  useEffect(() => {
    changeBackground(resultBgDesktop); 
  }, [changeBackground]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 600);
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

useEffect(() => {
  changeBackground(isMobile ? resultBgMobile : resultBgDesktop);
}, [changeBackground, isMobile]);


  useEffect(() => {
    const { childName: name, childDream: dream,childDOB: dob, imageUrl: url } = location.state;
    if (name) setChildName(name);
    if (dream) setChildDream(dream);
    if (dob) setChildDOB(dob);
    if (url) setImageURL(url);

    if (name && dream && dob && url) {
      setCanProcess(true);
    }
    return () => {
      setImageURL("");
      setChildName("");
      setChildDream("");
      setChildDOB("");
      setCanProcess(false);
      setIsLoading(false);
    };
  }, [location.state]);

  const captureContent = async (purpose = "download") => {
    if (!frameContainerRef.current ||!canProcess) {
      alert( purpose === "download"? "Content not ready for download." : "Content not ready for sharing.");
      return null;
    }
    setIsLoading(true);

    try {
      const canvas = await html2canvas(frameContainerRef.current, {
        scale: 2.5,
        useCORS: true,
        logging: true,
        backgroundColor: null,
      });
      return canvas;
    } catch (error) {
      console.error(`Error capturing content for ${purpose}:`, error);
      alert(`Error generating image for ${purpose}. Check console.`);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownload = async () => {
    const canvas = await captureContent("download");
    if (canvas) {
      const dataUrl = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = `${childDream}_${childName}_aspiration_ui_capture.png`.replace(/\s+/g, '_').toLowerCase();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleRestart = () => {
    navigate('/'); // Navigate to the Welcome page
  };


  return (
    <Layout>
      <div className="result-card-new">
        
        {/* THIS IS THE ONLY DIV WE WILL CAPTURE. Attach the ref here. */}
        <div className="frame-container-rp" ref={frameContainerRef}>

          {/* Layer 0: The processed child image */}
          <img
            src={imageURL}
            alt="Child's Aspiration"
            className="processed-image-rp"
            crossOrigin="anonymous" 
          />
          
          {/* Layer 2: The text details on top */}
          <div className="details-overlay-rp">
            {/* <span className="detail-label"></span> */}
            <span className="detail-value-name">{childName}</span>
            {/* <span className="detail-label dreams-label"></span> */}
            <span className="detail-value-dream">{childDream}</span>
          </div>

          {/* Layer 1 (the frame image) will be applied via CSS to this container */}
          {/* We use a pseudo-element `::before` for this in the CSS. */}

        </div>

        <div className="action-buttons-rp">
          <button
            onClick={handleDownload}
            className="result-action-button-rp download-rp"
            disabled={!canProcess || isLoading}
          >
            {isLoading? 'Processing...' : <><img src={downloadIcon} alt="" className="button-icon-rp" /> Download</>}
          </button>
          <button
            onClick={handleRestart}
            className="result-action-button-rp restart-rp" // Add a new class for specific styling if needed
            disabled={isLoading} // Disable while other actions are processing
          >
             {/* You can use an icon or just text */}
             {isLoading? 'Processing...' : <>Home Page</>}
          </button>
          
        </div>
      </div>
    </Layout>
  );
};

export default ResultPage;

// Local testing
// import React, { useEffect, useState, useRef } from "react";
// import "./ResultPage.css"; // Your existing CSS
// import Layout from "./Layout";
// import downloadIcon from "../assets/download_icon.png";
// // import shareIcon from "../assets/share_icon.png";
// import html2canvas from 'html2canvas';
// import { useLocation } from "react-router-dom"; // <-- IMPORT useLocation
// import { useNavigate } from "react-router-dom"; // <-- IMPORT useNavigate
// import { useBackground } from '../context/BackgroundContext'; 
// import resultBgDesktop from '../assets/login_page_4k_latest.jpg';
// import resultBgMobile from '../assets/login_phone_long.jpg';

// const ResultPage = () => {
//   const [imageURL, setImageURL] = useState("");
//   const [childName, setChildName] = useState("");
//   const [childDream, setChildDream] = useState("");
//   const [childDOB, setChildDOB] = useState("");
//   const [canProcess, setCanProcess] = useState(false);
//   const [isLoading, setIsLoading] = useState(false); // Combined loading state

//   const frameContainerRef = useRef(null);
//   const navigate = useNavigate(); // <-- INITIALIZE useNavigate
//   const location = useLocation(); // <-- INITIALIZE useLocation
//   const { changeBackground } = useBackground();

//   useEffect(() => {
//     changeBackground(resultBgDesktop); 
//   }, [changeBackground]);

//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

// useEffect(() => {
//   const handleResize = () => {
//     setIsMobile(window.innerWidth <= 600);
//   };

//   window.addEventListener("resize", handleResize);
//   return () => window.removeEventListener("resize", handleResize);
// }, []);

// useEffect(() => {
//   changeBackground(isMobile ? resultBgMobile : resultBgDesktop);
// }, [changeBackground, isMobile]);


//   useEffect(() => {
//     const { childName: name, childDream: dream,childDOB: dob, imageUrl: url } = location.state;
//     if (name) setChildName(name);
//     if (dream) setChildDream(dream);
//     if (dob) setChildDOB(dob);
//     if (url) setImageURL(url);

//     if (name && dream && dob && url) {
//       setCanProcess(true);
//     }
//     return () => {
//       setImageURL("");
//       setChildName("");
//       setChildDream("");
//       setChildDOB("");
//       setCanProcess(false);
//       setIsLoading(false);
//     };
//   }, [location.state]);

//   const captureContent = async (purpose = "download") => {
//     if (!frameContainerRef.current ||!canProcess) {
//       alert( purpose === "download"? "Content not ready for download." : "Content not ready for sharing.");
//       return null;
//     }
//     setIsLoading(true);

//     try {
//       const canvas = await html2canvas(frameContainerRef.current, {
//         scale: 2.5,
//         useCORS: true,
//         logging: true,
//         backgroundColor: null,
//       });
//       return canvas;
//     } catch (error) {
//       console.error(`Error capturing content for ${purpose}:`, error);
//       alert(`Error generating image for ${purpose}. Check console.`);
//       return null;
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleDownload = async () => {
//     const canvas = await captureContent("download");
//     if (canvas) {
//       const dataUrl = canvas.toDataURL('image/png');
//       const link = document.createElement('a');
//       link.href = dataUrl;
//       link.download = `${childDream}_${childName}_aspiration_ui_capture.png`.replace(/\s+/g, '_').toLowerCase();
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     }
//   };

//   const handleRestart = () => {
//     navigate('/'); // Navigate to the Welcome page
//   };


//   return (
//     <Layout>
//       <div className="result-card-new">
        
//         {/* THIS IS THE ONLY DIV WE WILL CAPTURE. Attach the ref here. */}
//         <div className="frame-container-rp" ref={frameContainerRef}>

//           {/* Layer 0: The processed child image */}
//           <img
//             src={imageURL}
//             alt="Child's Aspiration"
//             className="processed-image-rp"
//             crossOrigin="anonymous" 
//           />
          
//           {/* Layer 2: The text details on top */}
//           <div className="details-overlay-rp">
//             {/* <span className="detail-label"></span> */}
//             <span className="detail-value-name">{childName}</span>
//             {/* <span className="detail-label dreams-label"></span> */}
//             <span className="detail-value-dream">{childDream}</span>
//           </div>

//           {/* Layer 1 (the frame image) will be applied via CSS to this container */}
//           {/* We use a pseudo-element `::before` for this in the CSS. */}

//         </div>

//         <div className="action-buttons-rp">
//           <button
//             onClick={handleDownload}
//             className="result-action-button-rp download-rp"
//             disabled={!canProcess || isLoading}
//           >
//             {isLoading? 'Processing...' : <><img src={downloadIcon} alt="" className="button-icon-rp" /> Download</>}
//           </button>
//           <button
//             onClick={handleRestart}
//             className="result-action-button-rp restart-rp" // Add a new class for specific styling if needed
//             disabled={isLoading} // Disable while other actions are processing
//           >
//              {/* You can use an icon or just text */}
//              {isLoading? 'Processing...' : <>Home Page</>}
//           </button>
          
//         </div>
//       </div>
//     </Layout>
//   );
// };

// export default ResultPage;
